module.exports = __webpack_public_path__ + "static/choir-52d817a3218480f60890feceb5e9dd4c.jpg";